import { render, staticRenderFns } from "./dashboard-databricks-embed.vue?vue&type=template&id=10569426"
import script from "./dashboard-databricks-embed.vue?vue&type=script&lang=js"
export * from "./dashboard-databricks-embed.vue?vue&type=script&lang=js"
import style0 from "./dashboard-databricks-embed.vue?vue&type=style&index=0&id=10569426&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports